export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.f9b010f9.worker.js");
}
